// extracted by mini-css-extract-plugin
module.exports = {"modal":"_0f19004","header":"_529c9db","body":"_7395fb1","overlay":"_9258158","rootDisplayBlock":"_d6cd6b0"};